<web-player [data]="this.playerData" [ready]="this.playerDataReady" class="w-full"></web-player>
